//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams} from '@/utils/util.js'
import footerNav from '@/components/footerNav'

export default {
  name: "PurchaseDetailMore",
  components: {
    footerNav
  },
  data() {
    return {
      tableData:[],
      purchaseOrderId:'',
    }
  },
  created() {
    if(this.$route.query.purchaseOrderId){
      this.purchaseOrderId = this.$route.query.purchaseOrderId
      this.getList()
    }
  },
  mounted() {
  },
  methods: {
    getList() {
      var params = {
        "purchaseOrderId": this.purchaseOrderId,
        "start":0,
        "size":1000,
        "orderKey":"crtTime",
        "desc":true,
      };
      axiosApi.pagePurchaseOrderGoodsList(params).then(res => {
        this.tableData = res.content.list||[]
      })
    },
    toAll(row){
      this.$router.push({name:'purchaseDetailAll',query:{purchaseOrderId:this.purchaseOrderId,spuCode:row.spuCode,colorCode:row.colorCode}})
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/purchase/detailMore.vue